"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import MemeDropTraits from "@/components/memes/drops/MemeDropTraits";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { convertApiDropToExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
import WaveWinnersDropHeaderAuthorPfp from "./header/WaveWinnersDropHeaderAuthorPfp";
interface MemesWaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const MemesWaveWinnersDrop: React.FC<MemesWaveWinnersDropProps> = t0 => {
  const $ = _c(142);
  const {
    winner,
    wave,
    onDropClick
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  const title = winner.drop.metadata.find(_temp)?.data_value ?? "Artwork Title";
  const description = winner.drop.metadata.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
  let t2;
  if ($[2] !== winner.drop.parts) {
    t2 = winner.drop.parts.at(0)?.media.at(0);
    $[2] = winner.drop.parts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const artworkMedia = t2;
  const rating = winner.drop.rating || 0;
  const isPositive = rating >= 0;
  const ratersCount = winner.drop.raters_count;
  let creditType;
  let extendedDrop;
  let hasUserVoted;
  let isUserVoteNegative;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let userVote;
  if ($[4] !== artworkMedia || $[5] !== description || $[6] !== hasTouchScreen || $[7] !== isPositive || $[8] !== onDropClick || $[9] !== rating || $[10] !== title || $[11] !== touchHandlers || $[12] !== wave.voting.credit_type || $[13] !== winner) {
    const topVoters = winner.drop.top_raters.slice(0, 3);
    creditType = WAVE_VOTING_LABELS[wave.voting.credit_type];
    hasUserVoted = winner.drop.context_profile_context?.rating !== undefined && winner.drop.context_profile_context.rating !== 0;
    userVote = winner.drop.context_profile_context?.rating ?? 0;
    isUserVoteNegative = userVote < 0;
    let t18;
    if ($[34] !== winner.drop) {
      t18 = convertApiDropToExtendedDrop(winner.drop);
      $[34] = winner.drop;
      $[35] = t18;
    } else {
      t18 = $[35];
    }
    extendedDrop = t18;
    if ($[36] !== extendedDrop || $[37] !== onDropClick) {
      t16 = () => onDropClick(extendedDrop);
      $[36] = extendedDrop;
      $[37] = onDropClick;
      $[38] = t16;
    } else {
      t16 = $[38];
    }
    t17 = "touch-select-none tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition-all tw-duration-300 tw-ease-out";
    t15 = "tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-shadow-[0_0_15px_rgba(251,191,36,0.08)] tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-border-[#fbbf24]/20";
    t10 = "tw-flex tw-flex-col";
    t11 = touchHandlers;
    let t19;
    if ($[39] !== winner) {
      t19 = <WaveWinnersDropHeaderAuthorPfp winner={winner} size="sm" />;
      $[39] = winner;
      $[40] = t19;
    } else {
      t19 = $[40];
    }
    let t20;
    if ($[41] !== winner.drop.author.handle || $[42] !== winner.drop.author.id || $[43] !== winner.drop.author.primary_address) {
      t20 = winner.drop.author.handle ? <UserProfileTooltipWrapper user={winner.drop.author.handle}><Link href={`/${winner.drop.author.handle}`} onClick={_temp3} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{winner.drop.author.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${winner.drop.author.handle ?? winner.drop.author.primary_address}`} onClick={_temp4} scroll={false} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{winner.drop.author.handle ?? winner.drop.author.id}</span></Link>;
      $[41] = winner.drop.author.handle;
      $[42] = winner.drop.author.id;
      $[43] = winner.drop.author.primary_address;
      $[44] = t20;
    } else {
      t20 = $[44];
    }
    let t21;
    if ($[45] !== winner.drop.author.level) {
      t21 = <UserCICAndLevel level={winner.drop.author.level} size={UserCICAndLevelSize.SMALL} />;
      $[45] = winner.drop.author.level;
      $[46] = t21;
    } else {
      t21 = $[46];
    }
    const t22 = `memes-winner-author-badges-${winner.drop.id}`;
    let t23;
    if ($[47] !== t22 || $[48] !== winner.drop.author) {
      t23 = <DropAuthorBadges profile={winner.drop.author} tooltipIdPrefix={t22} />;
      $[47] = t22;
      $[48] = winner.drop.author;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    let t24;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = <span className="tw-text-sm tw-text-iron-500">•</span>;
      $[50] = t24;
    } else {
      t24 = $[50];
    }
    let t25;
    if ($[51] !== winner.drop.created_at) {
      t25 = <WaveDropTime timestamp={winner.drop.created_at} />;
      $[51] = winner.drop.created_at;
      $[52] = t25;
    } else {
      t25 = $[52];
    }
    let t26;
    if ($[53] !== t20 || $[54] !== t21 || $[55] !== t23 || $[56] !== t25) {
      t26 = <div className="tw-flex tw-items-center"><div className="-tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t20}{t21}{t23}{t24}{t25}</div></div>;
      $[53] = t20;
      $[54] = t21;
      $[55] = t23;
      $[56] = t25;
      $[57] = t26;
    } else {
      t26 = $[57];
    }
    let t27;
    if ($[58] !== t19 || $[59] !== t26) {
      t27 = <div className="tw-flex tw-gap-x-2">{t19}{t26}</div>;
      $[58] = t19;
      $[59] = t26;
      $[60] = t27;
    } else {
      t27 = $[60];
    }
    let t28;
    if ($[61] !== extendedDrop || $[62] !== hasTouchScreen) {
      t28 = !hasTouchScreen && <div className="tw-flex tw-flex-shrink-0 tw-items-center"><div className="tw-h-8"><WaveDropActionsOpen drop={extendedDrop} /></div></div>;
      $[61] = extendedDrop;
      $[62] = hasTouchScreen;
      $[63] = t28;
    } else {
      t28 = $[63];
    }
    if ($[64] !== t27 || $[65] !== t28) {
      t12 = <div className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4 tw-pb-3"><div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t27}{t28}</div></div>;
      $[64] = t27;
      $[65] = t28;
      $[66] = t12;
    } else {
      t12 = $[66];
    }
    const t29 = artworkMedia?.mime_type;
    let t30;
    if ($[67] !== t29 || $[68] !== winner.drop.id) {
      t30 = <MediaTypeBadge mimeType={t29} dropId={winner.drop.id} size="sm" />;
      $[67] = t29;
      $[68] = winner.drop.id;
      $[69] = t30;
    } else {
      t30 = $[69];
    }
    let t31;
    if ($[70] !== title) {
      t31 = <h3 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-100">{title}</h3>;
      $[70] = title;
      $[71] = t31;
    } else {
      t31 = $[71];
    }
    let t32;
    if ($[72] !== t30 || $[73] !== t31) {
      t32 = <div className="tw-flex tw-items-center tw-gap-x-2">{t30}{t31}</div>;
      $[72] = t30;
      $[73] = t31;
      $[74] = t32;
    } else {
      t32 = $[74];
    }
    let t33;
    if ($[75] !== description) {
      t33 = <p className="tw-mb-0 tw-line-clamp-2 tw-text-sm tw-text-iron-400">{description}</p>;
      $[75] = description;
      $[76] = t33;
    } else {
      t33 = $[76];
    }
    if ($[77] !== t32 || $[78] !== t33) {
      t13 = <div className="tw-px-4 tw-pb-4 tw-pt-4"><div className="tw-space-y-1">{t32}{t33}</div></div>;
      $[77] = t32;
      $[78] = t33;
      $[79] = t13;
    } else {
      t13 = $[79];
    }
    if ($[80] !== artworkMedia) {
      t14 = artworkMedia && <div className="tw-flex tw-h-96 tw-justify-center tw-bg-iron-950"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
      $[80] = artworkMedia;
      $[81] = t14;
    } else {
      t14 = $[81];
    }
    t8 = "tw-mt-4 tw-space-y-4 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/5 tw-bg-iron-900/30 tw-p-4";
    if ($[82] !== winner.drop) {
      t9 = <MemeDropTraits drop={winner.drop} />;
      $[82] = winner.drop;
      $[83] = t9;
    } else {
      t9 = $[83];
    }
    t6 = "tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2";
    const t34 = `tw-text-sm tw-font-bold ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
    let t35;
    if ($[84] !== rating) {
      t35 = formatNumberWithCommas(rating);
      $[84] = rating;
      $[85] = t35;
    } else {
      t35 = $[85];
    }
    let t36;
    if ($[86] !== t34 || $[87] !== t35) {
      t36 = <span className={t34}>{t35}</span>;
      $[86] = t34;
      $[87] = t35;
      $[88] = t36;
    } else {
      t36 = $[88];
    }
    let t37;
    if ($[89] !== creditType) {
      t37 = <span className="tw-text-sm tw-text-iron-500">{creditType} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
      $[89] = creditType;
      $[90] = t37;
    } else {
      t37 = $[90];
    }
    if ($[91] !== t36 || $[92] !== t37) {
      t7 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t36}{t37}</div>;
      $[91] = t36;
      $[92] = t37;
      $[93] = t7;
    } else {
      t7 = $[93];
    }
    t5 = "tw-flex tw-items-center tw-gap-2";
    t3 = "tw-flex tw-items-center -tw-space-x-2";
    t4 = topVoters.map(_temp6);
    $[4] = artworkMedia;
    $[5] = description;
    $[6] = hasTouchScreen;
    $[7] = isPositive;
    $[8] = onDropClick;
    $[9] = rating;
    $[10] = title;
    $[11] = touchHandlers;
    $[12] = wave.voting.credit_type;
    $[13] = winner;
    $[14] = creditType;
    $[15] = extendedDrop;
    $[16] = hasUserVoted;
    $[17] = isUserVoteNegative;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
    $[25] = t17;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = userVote;
  } else {
    creditType = $[14];
    extendedDrop = $[15];
    hasUserVoted = $[16];
    isUserVoteNegative = $[17];
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t13 = $[21];
    t14 = $[22];
    t15 = $[23];
    t16 = $[24];
    t17 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    t8 = $[31];
    t9 = $[32];
    userVote = $[33];
  }
  let t18;
  if ($[94] !== t3 || $[95] !== t4) {
    t18 = <div className={t3}>{t4}</div>;
    $[94] = t3;
    $[95] = t4;
    $[96] = t18;
  } else {
    t18 = $[96];
  }
  let t19;
  if ($[97] !== ratersCount) {
    t19 = formatNumberWithCommas(ratersCount);
    $[97] = ratersCount;
    $[98] = t19;
  } else {
    t19 = $[98];
  }
  const t20 = ratersCount === 1 ? "voter" : "voters";
  let t21;
  if ($[99] !== t20) {
    t21 = <span className="tw-font-normal tw-text-iron-500">{t20}</span>;
    $[99] = t20;
    $[100] = t21;
  } else {
    t21 = $[100];
  }
  let t22;
  if ($[101] !== t19 || $[102] !== t21) {
    t22 = <span className="tw-text-sm tw-font-semibold tw-text-iron-200">{t19}{" "}{t21}</span>;
    $[101] = t19;
    $[102] = t21;
    $[103] = t22;
  } else {
    t22 = $[103];
  }
  let t23;
  if ($[104] !== t18 || $[105] !== t22 || $[106] !== t5) {
    t23 = <div className={t5}>{t18}{t22}</div>;
    $[104] = t18;
    $[105] = t22;
    $[106] = t5;
    $[107] = t23;
  } else {
    t23 = $[107];
  }
  let t24;
  if ($[108] !== creditType || $[109] !== hasUserVoted || $[110] !== isUserVoteNegative || $[111] !== userVote) {
    t24 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-font-normal tw-text-iron-400">{creditType}</span></span></div></div>;
    $[108] = creditType;
    $[109] = hasUserVoted;
    $[110] = isUserVoteNegative;
    $[111] = userVote;
    $[112] = t24;
  } else {
    t24 = $[112];
  }
  let t25;
  if ($[113] !== t23 || $[114] !== t24 || $[115] !== t6 || $[116] !== t7) {
    t25 = <div className={t6}>{t7}{t23}{t24}</div>;
    $[113] = t23;
    $[114] = t24;
    $[115] = t6;
    $[116] = t7;
    $[117] = t25;
  } else {
    t25 = $[117];
  }
  let t26;
  if ($[118] !== t25 || $[119] !== t8 || $[120] !== t9) {
    t26 = <div className={t8}>{t9}{t25}</div>;
    $[118] = t25;
    $[119] = t8;
    $[120] = t9;
    $[121] = t26;
  } else {
    t26 = $[121];
  }
  let t27;
  if ($[122] !== extendedDrop || $[123] !== hasTouchScreen || $[124] !== isActive || $[125] !== setIsActive) {
    t27 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={extendedDrop} onOpenChange={() => setIsActive(false)} /></div></CommonDropdownItemsMobileWrapper>, document.body);
    $[122] = extendedDrop;
    $[123] = hasTouchScreen;
    $[124] = isActive;
    $[125] = setIsActive;
    $[126] = t27;
  } else {
    t27 = $[126];
  }
  let t28;
  if ($[127] !== t10 || $[128] !== t11 || $[129] !== t12 || $[130] !== t13 || $[131] !== t14 || $[132] !== t26 || $[133] !== t27) {
    t28 = <div className={t10} {...t11}>{t12}{t13}{t14}{t26}{t27}</div>;
    $[127] = t10;
    $[128] = t11;
    $[129] = t12;
    $[130] = t13;
    $[131] = t14;
    $[132] = t26;
    $[133] = t27;
    $[134] = t28;
  } else {
    t28 = $[134];
  }
  let t29;
  if ($[135] !== t15 || $[136] !== t28) {
    t29 = <div className={t15}>{t28}</div>;
    $[135] = t15;
    $[136] = t28;
    $[137] = t29;
  } else {
    t29 = $[137];
  }
  let t30;
  if ($[138] !== t16 || $[139] !== t17 || $[140] !== t29) {
    t30 = <div onClick={t16} className={t17}>{t29}</div>;
    $[138] = t16;
    $[139] = t17;
    $[140] = t29;
    $[141] = t30;
  } else {
    t30 = $[141];
  }
  return t30;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(e_0) {
  return e_0.stopPropagation();
}
function _temp5(e_1) {
  return e_1.stopPropagation();
}
function _temp6(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle ?? voter.profile.id}`} onClick={_temp5} scroll={false} className="tw-transition-transform desktop-hover:hover:tw-translate-y-[-2px]" data-tooltip-id={`voter-${voter.profile.handle ?? voter.profile.primary_address}-${voter.rating}`}>{voter.profile.pfp ? <Image className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={getScaledImageUri(voter.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${voter.profile.handle ?? voter.profile.id}'s profile picture`} width={24} height={24} /> : <div className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle ?? voter.profile.primary_address}-${voter.rating}`} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}>{voter.profile.handle} -{" "}{formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}